import React, { CSSProperties } from 'react';
import Typo from '../../../../components/atom/Typo';
import { ReactComponent as AvatarIcon } from '../../../../assets/icon-avatar.svg';
import styled from 'styled-components';

export interface ReviewReviewQuestionProfileProps {
  name: string;
  imageUrl?: string;
  treatmentCategory?: string;
  style?: CSSProperties;
}
function ReviewQuestionProfile(props: ReviewReviewQuestionProfileProps) {
  const { style, name, imageUrl, treatmentCategory } = props;
  return (
    <div style={style} className="flex gap-2 items-center justify-center">
      {imageUrl ? (
        <img
          style={{
            borderRadius: 25,
          }}
          width={40}
          src={imageUrl}
          alt="PF_IMG"
        />
      ) : (
        <div
          style={{
            background: '#fafafa',
            width: 40,
            height: 40,
            borderRadius: 20,
          }}
        >
          <AvatarIcon width={40} height={40} />
        </div>
      )}
      <Typo type="b-16">{name}</Typo>
      {treatmentCategory && (
        <CategoryTag $color="green">{treatmentCategory}</CategoryTag>
      )}
    </div>
  );
}

export default ReviewQuestionProfile;

const CategoryTag = styled.span<{
  $color: 'blue' | 'yellow' | 'red' | 'gray' | 'green';
}>`
  flex-grow: 0;
  width: initial;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  padding: 4px 7px;
  color: ${(props) => {
    switch (props.$color) {
      case 'gray':
        return 'rgb(100, 116, 139)';
      case 'blue':
        return '#005CE1';
      case 'yellow':
        return '#d46b08';
      case 'red':
        return '#cf1322';
      case 'green':
        return 'rgb(40, 117, 72)';
      default:
        return '#E17700';
    }
  }};
  background: ${(props) => {
    switch (props.$color) {
      case 'gray':
        return 'rgb(248, 250, 252)';
      case 'blue':
        return '#E5F2FF';
      case 'yellow':
        return '#fff7e6';
      case 'red':
        return '#fff1f0';
      case 'green':
        return 'rgb(244, 252, 247)';

      default:
        return '#E17700';
    }
  }};
`;
